import { useEffect, useRef } from 'react';
import { Show } from '@rails/upload';

const ModalUpload = ({ upload, onCloseModal = () => {} }) => {
  const modalRef = useRef(null);
  useEffect(() => {
    console.log('ICI', !!upload, !!modalRef.current);
    if (upload) {
      setTimeout(() => modalRef.current?.showModal()); // fix for mobile
    } else {
      modalRef.current?.close();
    }
  }, [upload]);
  return (
    <dialog
      className='modal'
      ref={modalRef}
      onClose={onCloseModal}
    >
      <div
        className='modal-box flex items-center justify-center max-w-9/10'
        onClick={onCloseModal}
      >
        <Show
          upload={upload}
          editable={true}
          limit={Math.min(window.innerWidth, window.innerHeight) * 0.7}
        />
      </div>
      <form
        method='dialog'
        className='modal-backdrop'
      >
        <button>close</button>
      </form>
    </dialog>
  );
};

export default ModalUpload;
